export default __webpack_public_path__ + "92167d6d3f45fe27cc4de276139ef4ee.svg";